import type { GetLectureDetail200ResponseResourcesItemType } from './getLectureDetail200ResponseResourcesItemType';

export type GetLectureDetail200ResponseResourcesItem = {
  /** 자료 제목 */
  title?: string;
  type?: GetLectureDetail200ResponseResourcesItemType;
  /** 자료 URL */
  url?: string;
};
